/**
 * @author Nihar <nihar.baishya@314ecorp.com>
 * @description Component for New Batch Upload Button
 */
import { Button, ButtonProps } from 'antd';
import { Plus } from '@icon-park/react';
import { Link } from 'react-router-dom';

import { getBatchEligibilityRequestPath } from 'utils/router';
import { AntClass } from '@veritable/common/constants/antd';

/**
 * New Batch Upload
 */
const NewBatchUpload: React.FC<ButtonProps> = (props) => {
	return (
		<Link to={getBatchEligibilityRequestPath()}>
			<Button type='primary' className={AntClass.secondaryButton} {...props}>
				<Plus />
				{'New Batch'}
			</Button>
		</Link>
	);
};

export default NewBatchUpload;
